import { BROADCAST_VALIDATE_JOIN_PARAMS } from 'actions/Types';

function validateBroadcast(state = false, action) {
  if (action.type === `${BROADCAST_VALIDATE_JOIN_PARAMS}_SUCCESS`) {
    return action.payload;
  }
  if (action.type === `${BROADCAST_VALIDATE_JOIN_PARAMS}_FAILURE`) {
    return false;
  }

  return state;
}

export default validateBroadcast;
